import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import WizardPaso5 from '../components/WizardPaso5';
import { AppAgendaContext } from '../context/AppAgendaContext';
import {
  Container, Content, Title, Subtitle, Form, Row, Col, Label, Input, PhoneInputWrapper,
  DoctorInfo, DoctorImage, DoctorDetails, Specialty, DoctorName, AppointmentDetails,
  Date as StyledDate, LocationTime, ButtonGroup, Button, IconoUbicacion, IconoReloj, InputFocusAzul 
} from '../styles/formStyles';
import 'bootstrap/dist/css/bootstrap.min.css';

const getDoctorImage = (odontRut) => {
  const imagePath = `/agenda/images/imgdocs/${odontRut}.jpg`;
  const defaultImagePath = `/agenda/images/imgdocs/sin_foto.jpg`;

  const image = new Image();
  image.src = imagePath;
  return image.complete ? imagePath : defaultImagePath;
};

const ConfirmaFonoMail = () => {
  useEffect(() => {
    const paso = 'ConfirmaFonoMail';

    if (!validarPaso(paso)) {
      registrarEventoVisual({
        paso,
        evento: 'flujo_bloqueado',
        descripcion: 'Intento de acceso directo no autorizado.'
      });
      window.location.href = '/';
      return;
    }

    setPasoActual(paso);
    logEventoBD({
      paso: 'ConfirmaFonoMail',
      evento: 'carga_pagina',
      descripcion: 'Usuario accede al paso ConfirmaFonoMail'
    });
    agregarPasoPermitido(paso);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "paso_confirma_fonomail" });
    setUltimoEventoGTM("paso_confirma_fonomail");
  }, []);
    
  const navigate = useNavigate();  
  const { contextData, setPasoActual, setUltimoEventoGTM, sessionId, utmData, registrarEventoVisual, validarPaso, agregarPasoPermitido, logEventoBD } = useContext(AppAgendaContext);
  const [telefono, setTelefono] = useState(contextData.pacTelefono || '');
  const [email, setEmail] = useState(contextData.pacCorreo || '');
  const originalTelefono = contextData.pacTelefono || '';
  const originalEmail = contextData.pacCorreo || '';
  const [nombrePaciente, setNombrePaciente] = useState('');
  const [formattedDate, setFormattedDate] = useState('');
  const [formattedTime, setFormattedTime] = useState('');
  const doctorImageSrc = getDoctorImage(contextData.odontRut);

  useEffect(() => {
    const nombre =
    contextData.pacienteInfo?.pacNombre ||
    contextData.pacNombre ||
    '';
  
    const primerNombre = nombre.split(' ')[0] || '';
    setNombrePaciente(primerNombre);
    setTelefono(contextData.pacTelefono || '');
    setEmail(contextData.pacCorreo || '');

    if (contextData.selectedDateTime) {
      const [date, time] = contextData.selectedDateTime.split(' ');
      /*const dateParts = date.split('-');
      const parsedDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);*/
      const parsedDate = new Date(`${date}T00:00:00`);

      const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
      const formattedDate = parsedDate.toLocaleDateString('es-ES', options);
      setFormattedDate(formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1));
      setFormattedTime(time);
    }
  }, [contextData]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!contextData.ageFecha || !contextData.ageHora || !contextData.horId) {
      alert('Faltan datos para confirmar la reserva. Verifica la selección anterior.');
      return;
    }

    await logEventoBD({
      paso: 'ConfirmaFonoMail',
      evento: 'click_siguiente',
      descripcion: 'Usuario presionó Siguiente en ConfirmaFonoMail'
    });

    navigate('/ConfirmaAgendamiento');
  };

  return (
    <Container>
      <WizardPaso5 />
      <Content>
        <Title><strong>{nombrePaciente}, Ya casi terminas!</strong></Title>
        <Subtitle style={{ fontSize: '18px' }}>
          <strong style={{ fontWeight: 'bold', color: '#00547F' }}></strong>Confirma tus datos para enviar tu reserva de hora
        </Subtitle>

        <Form onSubmit={handleSubmit}>

        <Row className="mb-3">
          {/* 📱 Teléfono */}
          <Col xs={12} md={6} className="mb-3">
            <Label><strong>Teléfono</strong></Label>
            <PhoneInputWrapper style={{
              display: 'flex',
              width: '100%',
              height: '40px',
              border: '1px solid #00788C', // ← CAMBIO DE COLOR
              borderRadius: '0.25rem',
              overflow: 'hidden',
              backgroundColor: '#fff'
            }}>
              <div style={{
                backgroundColor: '#E9F6F7',
                padding: '0 12px',
                fontSize: '15px',
                color: '#00788C',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 500,
                gap: '6px'
              }}>
                <i className="fas fa-phone-alt" style={{ fontSize: '13px' }}></i>
                +56 9
              </div>
              <InputFocusAzul
                type="text"
                value={telefono}

                onChange={(e) => {
                  const input = e.target.value.replace(/\D/g, '').slice(0, 8);
                  setTelefono(input);                  
                }}

                onBlur={() => {
                  const fueModificado = email !== originalEmail;

                  registrarEventoVisual({
                    paso: 'ConfirmaFonoMail',
                    evento: 'email_ingresado',
                    descripcion: `Correo ingresado: ${email}${fueModificado ? ' (modificado)' : ' (sin cambios)'}`
                  });

                  logEventoBD({
                    paso: 'ConfirmaFonoMail',
                    evento: 'email_ingresado',
                    descripcion: fueModificado ? 'Correo modificado por el usuario' : 'Correo sin cambios',
                    campo: 'correo',
                    valor: email
                  });
                }}

                placeholder="87912345"
                maxLength="8"
                required
                style={{
                  border: 'none',
                  borderLeft: '1px solid #00788C', // ← CAMBIO DE COLOR
                  borderRadius: '0',
                  flex: 1,
                  height: '100%',
                  paddingLeft: '12px'
                }}
              />
            </PhoneInputWrapper>
          </Col>

          {/* 📧 Correo Electrónico */}
          <Col xs={12} md={6}>
            <Label><strong>Correo Electrónico</strong></Label>
            <InputFocusAzul
              type="email"
              value={email}
              
              onChange={(e) => setEmail(e.target.value)}
              onBlur={() => {
                const fueModificado = telefono !== originalTelefono;

                registrarEventoVisual({
                  paso: 'ConfirmaFonoMail',
                  evento: 'telefono_ingresado',
                  descripcion: `Teléfono ingresado: +56 9 ${telefono}${fueModificado ? ' (modificado)' : ' (sin cambios)'}`
                });

                logEventoBD({
                  paso: 'ConfirmaFonoMail',
                  evento: 'telefono_ingresado',
                  descripcion: fueModificado ? 'Teléfono modificado por el usuario' : 'Teléfono sin cambios',
                  campo: 'telefono',
                  valor: telefono
                });
              }}

              placeholder="email@dominio.com"
              required
              style={{
                height: '40px',
                border: '1px solid #00788C', // ← CAMBIO DE COLOR
                borderRadius: '0.25rem'
              }}
            />
          </Col>
        </Row>

          <div className="alert alert-info" role="alert">
            <DoctorInfo>
              <DoctorImage src={doctorImageSrc} alt={`Foto del Dr. ${contextData.doctorName}`} />
              <DoctorDetails>
                <DoctorName><strong>{contextData.doctorName}</strong></DoctorName>
                <Specialty>{'Agendamiento Online'}</Specialty>
              </DoctorDetails>
              <AppointmentDetails>
                <StyledDate>{formattedDate}</StyledDate>
                <LocationTime>
                  <strong>
                    <IconoUbicacion className="fas fa-map-marker-alt" />
                    Sucursal : {contextData.sucursalNombre}
                  </strong>
                  &nbsp; - &nbsp;
                  <strong>
                    <IconoReloj className="fas fa-clock" />
                    {formattedTime}
                  </strong>
                </LocationTime>
              </AppointmentDetails>
            </DoctorInfo>
          </div>

          <ButtonGroup>
            <Button type="button" secondary onClick={() => navigate('/SeleccionaFecHora')}>
              Volver
            </Button>
            <Button type="submit">Siguiente</Button>
          </ButtonGroup>
        </Form>
      </Content>
    </Container>
  );
};

export default ConfirmaFonoMail;
